import { useMemo } from "react";
import { VStack } from "@chakra-ui/react";
import { FieldControl } from "./fields/FieldControl";
import { hasAnswer, visibleFieldsOf } from "./formValidation";
import type { FieldValue, FormField } from "./types";

interface Props {
  fields: FormField[];
  values: Record<number, FieldValue>;
  onChange: (fieldId: number, value: string | null, valueOptions?: string[] | null) => void;
  onUploadFile: (fieldId: number, file: File) => Promise<{ download_url: string; file_name: string }>;
  errors?: Record<number, string>;
  touched?: Record<number, boolean>;
}

export function DynamicFormRenderer({ fields, values, onChange, onUploadFile, errors, touched }: Props) {
  const visibleFields = useMemo(
    () => visibleFieldsOf(fields, values).sort((a, b) => a.order - b.order),
    [fields, values]
  );
  const anyTouched = useMemo(() => Object.values(touched ?? {}).some(Boolean), [touched]);

  return (
    <VStack align="stretch" spacing={5}>
      {visibleFields.map((field) => {
        const fieldValue = values[field.id];
        const errMsg = errors?.[field.id];
        const showError = !!errMsg && (touched?.[field.id] || hasAnswer(fieldValue) || anyTouched);
        return (
          <FieldControl
            key={field.id}
            field={field}
            fieldValue={fieldValue}
            onChange={onChange}
            onUploadFile={onUploadFile}
            showError={showError}
            errMsg={errMsg}
          />
        );
      })}
    </VStack>
  );
}